import React, { useState, useEffect } from "react";
import PincodeForm from "./form";
import Datatables from "../../../utils/table/datatable";
import { CorierRateColumns } from "helpers/DatatableColumns";
import { get } from "helpers/api_helper";
import { PINCODES } from "helpers/url_helper";

const Pincodes = () => {
    const [ isForm , setIsForm ] = useState(false);
    const [ pincodeList , setPincodeList ] = useState([]);
    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    
    const toggleForm = () => {
        const t = !isForm;
        setIsForm(!isForm);
        if(t == false){
            getPincodeList();
        }
    }
    
    const getPincodeList = async () => {
        const { success, data } = await get(`${PINCODES}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if(success){
            setPincodeList(data);
        }
    }

    useEffect(() => {
        const fetchData = setTimeout(() => {
            getPincodeList();
        }, 500);

        return () => clearTimeout(fetchData);
    }, [pagination.page, pagination.limit, pagination.search]);

    return (
        isForm ? <PincodeForm cb={toggleForm} /> :
            <Datatables 
                isSearch={true}
                columns = {CorierRateColumns}
                showTableOnly={true}
                rowsLength={pincodeList?.rows || 0}
                rows = {pincodeList?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}            
                title = "All Pincodes"
                loading = {false}
                isAdd = {true}
                isTableHead = {true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Pincodes;